import { useEffect } from "react";

export default function useProtectDevTools() {
  useEffect(() => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // ❌ Mobile devices skip DevTools protection
    if (isMobile) return;

    const showBlockedMessage = () => {
      document.body.innerHTML = `
        <div style="
          display:flex;
          justify-content:center;
          align-items:center;
          height:100vh;
          font-family:Arial, sans-serif;
          background:#f8f9fa;
          color:#333;
          text-align:center;
        ">
          <div>
            <h2>Access Restricted</h2>
            <p>
              For security and academic integrity reasons,
              this portal cannot be accessed while browser developer tools are open.
            </p>
            <p>Please close developer tools and refresh the page.</p>
          </div>
        </div>
      `;
    };

    const clearStorage = () => {
      localStorage.clear();
      sessionStorage.clear();
      console.clear();
    };

    const detectDevTools = () => {
      const threshold = 160;
      if (
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold
      ) {
        clearStorage();
        showBlockedMessage();
      }
    };

    const checkDevTools = () => {
      const start = performance.now();
      debugger;
      const end = performance.now();
      if (end - start > 100) {
        clearStorage();
        showBlockedMessage();
      }
    };

    const handle = () => {
      detectDevTools();
      checkDevTools();
    };

    window.addEventListener("resize", handle);
    const interval = setInterval(handle, 1000);

    handle();

    return () => {
      window.removeEventListener("resize", handle);
      clearInterval(interval);
    };
  }, []);
}
